import React, { useContext, useRef, useEffect } from 'react';
import { NavbarContext } from './NavbarContext.js';
import { useFocusManager } from '@react-aria/focus';

const NavbarMobileNotifications = () => {
    const { notificationMenuItems, notificationItemFormatter, noNotificationMessage, notificationMenuLinkWrapper } = useContext(NavbarContext);
    const focusManager = useFocusManager();
    const notificationItems = useRef([]);
    const handleKeyDown = (e) => {
        if (!focusManager)
            return;
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                focusManager.focusNext({ wrap: true });
                break;
            case 'ArrowUp':
                e.preventDefault();
                focusManager.focusPrevious({ wrap: true });
                break;
            case 'End':
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case 'Home':
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    const optionalProps = (e) => {
        const optionalProps = {};
        if (e && !e.querySelector('a')) {
            optionalProps.tabIndex = 0;
        }
        return optionalProps;
    };
    useEffect(() => {
        if (notificationItems.current[0]) {
            notificationItems.current[0].focus();
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: 'helix-unified-navbar__panel-header' }, "Notifications"),
        notificationMenuItems && notificationMenuItems.length > 0 ? (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        notificationMenuItems.map((item, index) => (React.createElement("div", { key: `mobile-notification-item-${index}`, className: 'helix-unified-navbar__mobile-menu-item' },
            React.createElement("span", Object.assign({ ref: (ref) => notificationItems.current.push(ref), onKeyDown: (e) => handleKeyDown(e), className: 'helix-unified-navbar__mobile-menu-notification-item' }, optionalProps(notificationItems.current[index])), notificationMenuLinkWrapper
                ? notificationMenuLinkWrapper({ item, props: {} })
                : notificationItemFormatter
                    ? notificationItemFormatter(item)
                    : item.label))))) : (React.createElement("div", { className: 'empty-state' }, noNotificationMessage))));
};

export { NavbarMobileNotifications as default };
//# sourceMappingURL=NavbarMobileNotifications.js.map
